/**
 * Version badge — small pill in the bottom-right of every page so you can
 * visually confirm which build you're looking at (for future rollback reference).
 */
export default function VersionBadge({ variant = 'default' }) {
  const label = 'NightBuZz OS · v1.0.0';
  return (
    <div
      data-testid="version-badge"
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 9998,
        background: 'rgba(0,0,0,0.75)',
        color: '#00FF41',
        border: '1px solid rgba(0,255,65,0.4)',
        padding: '4px 10px',
        borderRadius: 20,
        fontFamily: 'JetBrains Mono, ui-monospace, monospace',
        fontSize: 10,
        letterSpacing: 1,
        boxShadow: '0 0 8px rgba(0,255,65,0.25)',
        pointerEvents: 'none',
      }}
    >
      {label} · {variant}
    </div>
  );
}
